export const GENERAL_GRAPH = "GENERAL_GRAPH";
export const GRAPH_GRAPH_RESULTS = "GRAPH_GRAPH_RESULTS";
export const GENERAL_SLIDER_OPTION = "GENERAL_SLIDER_OPTION";
